export default "__VITE_ASSET__BRdvExbN__"